<template>
    <page :showBackButton="true">
        <h1>Einstellungen</h1>

        <template v-if="hostname === 'localhost'">
            <ion-card class="-light">
                <ion-list-header
                    ><ion-label>Magazin Nachrichten</ion-label>
                    <ion-button
                        fill="clear"
                        color="dark"
                        @click="showInfo('Magazin')"
                        size="medium"
                    >
                        <ion-icon
                            name="information-circle-outline"
                            slot="icon-only"
                        ></ion-icon
                    ></ion-button>
                </ion-list-header>
                <ion-list>
                    <ion-item
                        v-for="(motiveConfig, index) in $store.state
                            .motivesConfig"
                        :key="index"
                    >
                        <ion-label>{{ motiveConfig.magazinTitle }}</ion-label>
                        <base-toggle
                            :toggleClass="'-' + motiveConfig.path"
                            v-model="magazinTags[motiveConfig.magazinTag]"
                            :id="motiveConfig.magazinTag"
                            :disabled="
                                magazinTagsDisabled[motiveConfig.magazinTag]
                            "
                        ></base-toggle>
                    </ion-item>
                </ion-list>
            </ion-card>
        </template>

        <ion-card class="-light">
            <ion-list>
                <ion-list-header>Bildschirm</ion-list-header>
                <ion-item>
                    <ion-label>Dunkelmodus</ion-label>
                    <base-toggle
                        v-model="isDarkmode"
                        id="darkmode"
                        @click.native="toggleDarkmode()"
                    ></base-toggle>
                </ion-item>
            </ion-list>
        </ion-card>

        <template v-if="hostname === 'localhost' && isFingerprintVisible">
            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>Sicherheit</ion-list-header>
                    <ion-item>
                        <ion-label class="ion-text-wrap"
                            >{{ fingerprintText }} statt Kundenkennwort
                            verwenden</ion-label
                        >
                        <base-toggle
                            v-model="isFingerprint"
                            id="fingerprint"
                            @click.native="toggleFingerprint()"
                        ></base-toggle>
                    </ion-item>
                </ion-list>
            </ion-card>
        </template>

        <ion-card class="-light">
            <ion-list>
                <ion-list-header>Links</ion-list-header>
                <ion-item
                    button
                    @click="
                        changePage(
                            'https://www.wuestenrot.at/de/ueber-uns/karriere.html'
                        )
                    "
                >
                    <ion-label>Jobs</ion-label>
                </ion-item>
                <ion-item
                    button
                    @click="
                        changePage(
                            'https://www.klickmal.at/pages/impressum.html'
                        )
                    "
                >
                    <ion-label>Impressum</ion-label>
                </ion-item>
                <ion-item
                    button
                    @click="
                        changePage(
                            'https://www.klickmal.at/pages/rechtliche-hinweise.html'
                        )
                    "
                >
                    <ion-label>Rechtliche Hinweise & Datenschutz</ion-label>
                </ion-item>
            </ion-list>
        </ion-card>

        <template
            v-if="
                ('appVersion' in deviceInfo && deviceInfo.appVersion !== '') ||
                ('appBuild' in deviceInfo && deviceInfo.appBuild !== '')
            "
        >
            <ion-card class="-light">
                <ion-list>
                    <ion-list-header>App Informationen</ion-list-header>
                    <ion-item
                        v-if="
                            'appVersion' in deviceInfo &&
                            deviceInfo.appVersion !== ''
                        "
                    >
                        <ion-label>App Version</ion-label>
                        <b slot="end">{{ deviceInfo.appVersion }}</b>
                    </ion-item>
                    <ion-item
                        v-if="
                            'appBuild' in deviceInfo &&
                            deviceInfo.appBuild !== ''
                        "
                    >
                        <ion-label>App Build</ion-label>
                        <b slot="end">{{ deviceInfo.appBuild }}</b>
                    </ion-item>
                </ion-list>
            </ion-card>
        </template>
    </page>
</template>

<script>
import Page from "@/components/Page";
import BaseToggle from "@/components/BaseToggle";
import { Plugins, StatusBarStyle } from "@capacitor/core";
// import ExpansionCard from "@/components/ExpansionCard";
import { stringToFullHex } from "@/utils/string";
import { FingerprintAIO } from "@ionic-native/fingerprint-aio";
import { handleError } from "@/utils/error";

const {
    // UrbanAirshipPlugin,
    Device,
    StatusBar,
    Storage,
} = Plugins;

export default {
    components: { Page, BaseToggle },
    data() {
        return {
            magazinTags: {},
            magazinTagsDisabled: {},
            deviceInfo: {},
            isDarkmode: false,
            isFingerprint: true,
            fingerprintText: "Fingerabdruck",
            isFingerprintVisible: false,
            hostname: window.location.hostname,
            faio: FingerprintAIO,
        };
    },
    mounted() {
        Storage.get({ key: "darkmode" }).then(({ value: val }) => {
            if (val === null) {
                const prefersDark = window.matchMedia(
                    "(prefers-color-scheme: dark)"
                );
                if (window.navigator.userAgent.includes("AndroidDarkMode")) {
                    this.isDarkmode = true;
                } else {
                    this.isDarkmode = prefersDark.matches;
                }
            } else if (val === "true") {
                this.isDarkmode = true;
            }
        });
        this.faio
            .isAvailable()
            .then((result) => {
                if (result === "face") {
                    this.fingerprintText = "Face ID";
                }
                Storage.get({ key: "fingerprint" }).then(({ value: val }) => {
                    if (val === "false") {
                        this.isFingerprint = false;
                    }
                });
                this.isFingerprintVisible = true;
            })
            .catch((error) => handleError(error));
        Device.getInfo().then((info) => {
            this.deviceInfo = info;
            // console.log(this.deviceInfo);
        });
        for (let key in this.$store.state.motivesConfig) {
            let motiveConfig = this.$store.state.motivesConfig[key];
            this.$set(this.magazinTagsDisabled, motiveConfig.magazinTag, true);
            Storage.get({ key: motiveConfig.magazinTag })
                .then(({ value: val }) => {
                    if (val !== "false") {
                        this.$set(
                            this.magazinTags,
                            motiveConfig.magazinTag,
                            true
                        );
                    } else {
                        this.$set(
                            this.magazinTags,
                            motiveConfig.magazinTag,
                            false
                        );
                    }
                })
                .finally(() => {
                    this.$set(
                        this.magazinTagsDisabled,
                        motiveConfig.magazinTag,
                        false
                    );
                });
        }
    },
    watch: {
        magazinTags: {
            handler(magazinTags) {
                if (Capacitor.isNative) {
                    for (let key in magazinTags) {
                        this.$set(this.magazinTagsDisabled, key, true);
                        if (magazinTags[key]) {
                            Promise.all([
                                Storage.set({ key: key, value: "true" }),
                                // UrbanAirshipPlugin.addPushNotificationTag({
                                //     tag: key,
                                // }),
                            ]).finally(() => {
                                this.$set(this.magazinTagsDisabled, key, false);
                            });
                        } else {
                            Promise.all([
                                Storage.set({ key: key, value: "false" }),
                                // UrbanAirshipPlugin.removePushNotificationTag({
                                //     tag: key,
                                // }),
                            ]).finally(() => {
                                this.$set(this.magazinTagsDisabled, key, false);
                            });
                        }
                    }
                }
            },
            deep: true,
        },
    },
    methods: {
        showInfo(id) {
            if (id === "Magazin") {
                this.$ionic.alertController
                    .create({
                        header: "Aktuelle Artikel als Push Nachricht erhalten",
                        message:
                            "So verpasst du keine neuen Artikel aus unserem Magazin Mein Leben. Lass dir einfach Push Nachrichten auf dein Smartphone senden. Wähle dazu einfach die für dich passenden Lebensbereiche.",
                        buttons: ["Ok"],
                    })
                    .then((a) => {
                        a.present();
                    });
            }
        },
        changePage(path) {
            this.$router.push(path);
        },
        toggleDarkmode() {
            let storageValue = "false";
            if (this.isDarkmode) {
                storageValue = "true";
            }
            Storage.set({ key: "darkmode", value: storageValue }).then(() => {
                document.body.classList.toggle("dark", this.isDarkmode);
                if (Capacitor.isNative) {
                    StatusBar.setStyle({
                        style: this.isDarkmode
                            ? StatusBarStyle.Dark
                            : StatusBarStyle.Light,
                    });
                    const color = stringToFullHex(
                        getComputedStyle(document.body).getPropertyValue(
                            "--ion-background-color"
                        )
                    );
                    if (Capacitor.platform === "android") {
                        StatusBar.setBackgroundColor({ color: color });
                    }
                }
            });
        },
        toggleFingerprint() {
            if (!this.isFingerprint) {
                Storage.set({ key: "fingerprint", value: "false" });
            } else {
                this.faio
                    .show({
                        clientId: "Fingerprint-Wuestenrot", //Android: Used for encryption. iOS: used for dialogue if no `localizedReason` is given.
                        clientSecret: "qJ#HBa62}qy]m#p<kqxL", //Necessary for Android encrpytion of keys. Use random secret key.
                        disableBackup: true, //Only for Android(optional)
                        localizedFallbackTitle: "Pin benutzen", //Only for iOS
                        localizedReason: "Bitte authentifizieren", //Only for iOS
                    })
                    .then(() => {
                        Storage.set({ key: "fingerprint", value: "true" });
                    })
                    .catch(() => {
                        this.isFingerprint = false;
                    });
            }
        },
    },
};
</script>
